import apiCore from '../../utils/api-core';

// AI usage & cost (gohire-admin). ADR-033.
export function getAiUsage(params) {
    return apiCore.get('/api/v3/admin/ai-usage', { params });
}

export function getCompanies() {
    return apiCore.get('/api/v1/companies');
}
